// extracted by mini-css-extract-plugin
export default {"container":"docs_container__UT-1p","deviewText":"docs_deviewText__wPYqo","link":"docs_link__UlV54"};